import React from 'react';
import { render } from 'react-dom';
import StreamedianPlayer from './StreamedianPlayer';
import './index.css';

const App = () => (
	<div>
		<StreamedianPlayer id="test_video">
			<source src="rtsp://127.0.0.1:8554/test/" type="application/x-rtsp" />
		</StreamedianPlayer>
	</div>
);

render(<App />, document.getElementById('root'));
